import React from 'react';
import Page from "./components/Page";
import  { Features, UseCase, Pricing, Home, AboutUs } from "./containers"
import { Route, Switch, Redirect } from "react-router-dom";

export default () => {
  return (<Switch>
    <Route exact
           path="/" render={() =>
      <Page
        title="Lumio.id - Welcome"
        header="Smart Digital Signage Platform"
        className="header-home"
      >
        <Home/>
      </Page>
    }/>

    <Route exact
           path="/features" render={() =>
      <Page
        title="Lumio.id - Features"
        header="Do More with Your Display"
        className="header-features">
        <Features/>
      </Page>
    }/>

    <Route exact
           path="/use-case" render={() =>
      <Page
        title="Lumio.id - Use Case"
        header="Made To Be Used In Multiple Scenarios"
        className="header-use-case">
        <UseCase/>
      </Page>
    }/>
    <Route exact
           path="/pricing" render={() =>
      <Page
        title="Lumio.id - Pricing"
        header="We Got You Covered With These Plans"
        className="header-pricing">
        <Pricing/>
      </Page>
    }/>
    <Route exact
           path="/about" render={() =>
      <Page
        title="About"
        header="About Us"
        className="header-about">
        <AboutUs/>
      </Page>
    }/>
    <Route path="*" render={() => <Redirect to="/"/>}/>
  </Switch>)
}


// WEBPACK FOOTER //
// ./src/routes.js